module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-lifestyle@2x.b2f6daf5.png";